import { render, staticRenderFns } from "./ParameterNew.vue?vue&type=template&id=8cd935b6"
import script from "./ParameterNew.vue?vue&type=script&lang=js"
export * from "./ParameterNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports